import { render } from "./Hotspot18.5.vue?vue&type=template&id=5940f59e&scoped=true&ts=true"
import script from "./Hotspot18.5.vue?vue&type=script&lang=ts"
export * from "./Hotspot18.5.vue?vue&type=script&lang=ts"

import "./Hotspot18.5.vue?vue&type=style&index=0&id=5940f59e&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5940f59e"]])

export default __exports__